import moment from 'moment/moment'

import { splitIntervalByPeriod } from '@components/TimeLineGrid/helpers/splitIntervalByPeriod'

import { TimeLineDTOType } from '@types'

export const getDateIntervalsDefaultValue = (config: TimeLineDTOType) => {
  return splitIntervalByPeriod(
    config.timeInterval.start || moment(new Date()).startOf('month'),
    config.timeInterval.end || moment(new Date()).endOf('month'),
    'days'
  )
}
